export interface RemoveCarFilesQueries {
  fileId: string;
  carId: string;
}

export interface UpdateCarDocumentQueries {
  file: File;
  fileKey: 'registrationDoc' | 'insuranceDoc' | 'insuranceInformation';
}
export type UpdateCarDocumentQuery = Omit<UpdateCarDocumentQueries, 'file'> & {
  id: string;
};
export enum BEControllers {
  ORDERS = 'orders',
  CARS = 'cars',
  USERS = 'users',
  TRANSLATIONS = 'translations',
  NOTES = 'notes',
  UPCOMING_ACTIONS = 'upcoming-actions',
  DISCOUNTS = 'discounts',
  SUBSCRIPTIONS = 'subscriptions',
  CONTACT_US = 'contact-us',
  COMMENTS = 'comments',
  SUBSCRIPTION_PACKAGES = 'subscription-packages',
  PAYMENTS = 'payments',
}

interface IndexEndpoints {
  general: string;
  opWithId: (id: string) => string;
}

type UnaryFunction<T, R> = (arg: T) => R;

interface OrdersEndpoints extends IndexEndpoints {
  confirmOrder: UnaryFunction<string, string>;
  updateOrderFiles: UnaryFunction<string, string>;
  removeOrderFile: UnaryFunction<string, string>;
  confirmDropOff: UnaryFunction<string, string>;
  attachSecondaryDriver: UnaryFunction<string, string>;
  updateSecurityDepositDocument: UnaryFunction<string, string>;
  releaseSecurityDeposit: UnaryFunction<string, string>;
  updateMultipleOrders: UnaryFunction<string, string>;
  switchDeposit: UnaryFunction<string, string>;
  refund: UnaryFunction<string, string>;
  pendingOrders: string;
  approve: UnaryFunction<string, string>;
  refuse: UnaryFunction<string, string>;
  confirmPartiallyOrder: UnaryFunction<string, string>;
}

interface CarsEndpoints extends IndexEndpoints {
  getCarCreationProgress: string;
  addAvailabilityDates: UnaryFunction<string, string>;
  removeAvailableDate: UnaryFunction<string, string>;
  deleteSelectedCars: UnaryFunction<string[], string>;
  updateCarsStatuses: UnaryFunction<string, string>;
  duplicateCar: UnaryFunction<string, string>;
  removeCarFiles: UnaryFunction<RemoveCarFilesQueries, string>;
  updateCarDocument: UnaryFunction<UpdateCarDocumentQuery, string>;
  updateCarFile: UnaryFunction<string, string>;
  updateCarCoverImage: UnaryFunction<string, string>;
  updateCarInitialPhoto: UnaryFunction<string, string>;
  deleteCarInitialPhoto: UnaryFunction<string, string>;
  updateCarMedia: UnaryFunction<string, string>;
  getCarsByAvailability: string;
  search: string;
}

interface UsersEndpoints extends IndexEndpoints {
  registerUser: string;
  archiveUsers: UnaryFunction<string[], string>;
  removeUsers: UnaryFunction<string[], string>;
  getCustomerById: UnaryFunction<string, string>;
  getUserByEmail: UnaryFunction<string, string>;
  getAllStaffAccounts: string;
  getAllOwnerAccounts: string;
  invite: string;
  acceptInvitation: string;
  getMe: string;
  login: string;
  resetPassword: string;
  updatePassword: string;
  setNewPassword: string;
  createWithoutPassword: string;
  sendVerificationEmail: string;
  verifyAccount: string;
  socialLogin: string;
}
interface TranslationsEndpoints extends IndexEndpoints {
  export: string;
}
interface NotesEndpoints extends IndexEndpoints {
  deleteOrUpdate: UnaryFunction<string, string>;
}

interface UpcomingActionsEndpoints extends IndexEndpoints {}
interface SubscriptionsEndpoints extends IndexEndpoints {
  stopSubscription: UnaryFunction<string, string>;
}
interface DiscountsEndpoints extends IndexEndpoints {
  export: string;
  validate: string;
  removeDiscounts: (ids: string) => string;
}

interface ContactUsEndpoints extends IndexEndpoints {
  supports: string;
}

interface CommentsEndpoints extends IndexEndpoints {
  aboutUser: string;
}
interface SubscriptionsPackagesEndpoints extends IndexEndpoints {}
interface PaymentsEndpoints {
  createPaymentIntent: string;
  capturePayment: UnaryFunction<string, string>;
}

export interface Endpoints {
  [BEControllers.ORDERS]: OrdersEndpoints;
  [BEControllers.CARS]: CarsEndpoints;
  [BEControllers.USERS]: UsersEndpoints;
  [BEControllers.TRANSLATIONS]: TranslationsEndpoints;
  [BEControllers.NOTES]: NotesEndpoints;
  [BEControllers.UPCOMING_ACTIONS]: UpcomingActionsEndpoints;
  [BEControllers.DISCOUNTS]: DiscountsEndpoints;
  [BEControllers.SUBSCRIPTIONS]: SubscriptionsEndpoints;
  [BEControllers.CONTACT_US]: ContactUsEndpoints;
  [BEControllers.COMMENTS]: CommentsEndpoints;
  [BEControllers.SUBSCRIPTION_PACKAGES]: SubscriptionsPackagesEndpoints;
  [BEControllers.PAYMENTS]: PaymentsEndpoints;
}
